module.exports = __webpack_public_path__ + "img/happytable_info1.b8eb3a1e.jpg";